<!-- Chargement -->
@if (step === 'loading') {
<div class="flex justify-content-center p-4">
    <p-progressspinner [style]="{ width: '3rem', height: '3rem' }"></p-progressspinner>
</div>
}

<!-- Étape TOTP (step-up auth) -->
@if (step === 'totp') {
<div class="flex flex-column align-items-center gap-3">
    <p class="m-0 text-center text-color-secondary text-sm">
        Saisissez votre code d'authentification pour continuer.
    </p>
    <form [formGroup]="form" novalidate class="w-17rem">
        <div class="flex justify-content-center">
            <p-inputotp formControlName="code" [pAutoFocus]="true" [length]="6" [integerOnly]="true"></p-inputotp>
        </div>
    </form>
</div>
}

<!-- QR Code -->
@if (step === 'qrcode') {
<div class="flex flex-column align-items-center gap-3">
    <p class="m-0 text-center text-color-secondary text-sm">
        Scannez ce QR Code depuis votre application mobile Biifor.
    </p>
    <img [src]="qrCodeDataUrl" alt="QR Code" width="220" height="220" />
    <span class="text-sm text-color-secondary">Expire dans {{ countdown }}s</span>
</div>
}

<!-- Expiré -->
@if (step === 'expired') {
<div class="flex flex-column align-items-center gap-3">
    <p class="m-0 text-center text-color-secondary">Le QR Code a expiré.</p>
    <div class="flex justify-content-center">
        <p-button label="Générer un nouveau QR Code" icon="pi pi-refresh" [rounded]="true"
            (click)="onClickRetry()"></p-button>
    </div>
</div>
}